class BlogEditorial extends HTMLElement {
  constructor() {
    super();
    this.perLoad = parseInt(this.dataset.perLoad, 10) || 3;
    this.visibleCount = this.perLoad;
    this.sortOrder = 'newest';
  }

  connectedCallback() {
    this.list = this.querySelector('[data-blog-editorial-list]');
    this.rows = this.list ? Array.from(this.list.querySelectorAll('[data-blog-editorial-row]')) : [];
    this.sortSelect = this.querySelector('[data-blog-editorial-sort]');
    this.loadMoreButton = this.querySelector('[data-blog-editorial-load-more]');
    this.statusEl = this.querySelector('[data-blog-editorial-status]');
    this.totalCount = this.rows.length;

    if (this.sortSelect) {
      this.sortOrder = this.sortSelect.value || this.sortOrder;
      this.sortSelect.addEventListener('change', (event) => {
        this.sortOrder = event.target.value;
        this.render();
      });
    }

    if (this.loadMoreButton) {
      this.loadMoreButton.addEventListener('click', () => {
        this.visibleCount += this.perLoad;
        this.render();
      });
    }
  }

  render() {
    const sorted = this.rows.slice().sort((a, b) => {
      const timeA = parseInt(a.dataset.timestamp, 10) || 0;
      const timeB = parseInt(b.dataset.timestamp, 10) || 0;
      return this.sortOrder === 'oldest' ? timeA - timeB : timeB - timeA;
    });

    sorted.forEach((row, index) => {
      this.list.appendChild(row);
      row.hidden = index >= this.visibleCount;
    });

    const shown = Math.min(this.visibleCount, this.totalCount);

    if (this.statusEl) {
      this.statusEl.textContent = this.statusEl.dataset.template
        .replace('__SHOWN__', shown)
        .replace('__TOTAL__', this.totalCount);
    }

    if (this.loadMoreButton) {
      this.loadMoreButton.hidden = shown >= this.totalCount;
    }
  }
}

customElements.define('blog-editorial', BlogEditorial);
